import React from "react";
import useAuthStore from "../../stores/useAuthStore";
import { Link, useNavigate } from "react-router-dom";
import { Nav, NavbarToggler, NavItem, Badge } from "reactstrap";
import ButtonLogout from "../Button/ButtonLogout";
import ToggleHelp from "../../components/Help/ToggleHelp";
import LanguageToggle from "../LanguageToggle/LanguageToggle";
import { GetTeacherInformation } from "../../actions/teacherQueries";
import {
  EnvironmentInfo,
  EnvironmentColor,
} from "../EnvironmentInfo/EnvironmentInfo";
import MaintenanceMessage from "../MaintenanceMessage/MaintenanceMessage";
import MobileLogout from "../MobileLogout/MobileLogout";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GetNotifications } from "../../actions/adminQueries";
import IntrusiveNotificationModal from "../Modal/IntrusiveNotificationModal";
import useIntrusiveNotifications from "../../hooks/useIntrusiveNotifications";

function Header() {
  const roles = useAuthStore((state) => state.roles);

  var sidebarToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle("sidebar-hidden");
  };

  var mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  };

  const isTeacher = roles === "Teacher";
  const teacherInfo = GetTeacherInformation({ enabled: isTeacher });
  if (isTeacher) {
    document.body.classList.remove("sidebar-hidden");
  } else {
    document.body.classList.add("sidebar-hidden");
  }

  const showNotifications =
    roles === "Teacher" || roles === "Student";

  const notifications = GetNotifications({ enabled: showNotifications });
  const notificationsList = notifications.data ?? [];

  const {
    showIntrusiveModal,
    intrusiveNotifications,
    handleCloseIntrusiveModal,
    handleDismissIntrusiveModal,
  } = useIntrusiveNotifications({ enabled: showNotifications });
  const navigate = useNavigate();

  const handleGoToNotificationCenter = () => {
    handleDismissIntrusiveModal();
    const notificationPath =
      roles === "Teacher"
        ? "/teacher/notifications"
        : "/student/notifications";
    navigate(notificationPath);
  };

  return (
    <header
      className="app-header navbar"
      id="main__navbar"
      style={EnvironmentColor()}
    >
      {roles === "Student" && (
        <NavbarToggler className="d-lg-none" onClick={mobileSidebarToggle}>
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
      )}
      <Link to="/" className="main__navbar-brand">
        <div className="navbar-brand a" style={EnvironmentColor()} />
      </Link>

      {roles === "Student" && (
        <NavbarToggler className="d-md-down-none" onClick={sidebarToggle}>
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
      )}
      {roles === "Teacher" && (
        <NavbarToggler className="d-lg-none" onClick={mobileSidebarToggle}>
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
      )}
      {roles === "Teacher" && (
        <NavbarToggler className="d-md-down-none" onClick={sidebarToggle}>
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
      )}

      <MaintenanceMessage />
      <EnvironmentInfo />
      {roles === "Teacher" &&
        teacherInfo != null &&
        !teacherInfo.isLoading && (
          <Nav className="Header-Nav--Navgroup stroke">
            {teacherInfo.data?.purchaser && (
              <>
                <NavItem className="Header-Nav-Item">
                  <Link to="/teacher/shop" className="Header-Nav-Item--link">
                    <FormattedMessage id="Shop" />
                  </Link>
                </NavItem>
                <NavItem className="Header-Nav-Item">
                  <Link
                    to="/teacher/invoicehistory"
                    className="Header-Nav-Item--link"
                  >
                    <FormattedMessage id="Navigation_Teacher_Invoice_History" />
                  </Link>
                </NavItem>
              </>
            )}
            <NavItem className="Header-Nav-Item">
              <Link to="/teacher/aboutUs" className="Header-Nav-Item--link">
                <FormattedMessage id="AboutUs" />
              </Link>
            </NavItem>
          </Nav>
        )}
      {showNotifications && (
        <Nav className="Header-Nav--Navgroup stroke">
          <Link
            to={
              roles === "Teacher"
                ? "/teacher/notifications"
                : "/student/notifications"
            }
            className="Header-Nav-Item--Notifications"
          >
            <FontAwesomeIcon icon="bell" color="#20A8DA" />
            {notificationsList.filter(
              (notif) => !notif.isSeenByMe && !notif.notice.isDeleted
            ).length > 0 && (
              <Badge
                className="mb-4 notifications-count-badge"
                style={{
                  borderRadius: "50%",
                  position: "relative",
                  top: "-.5rem",
                  paddingTop: "0.15rem",
                  color: "white",
                  border: "1px solid red",
                }}
              >
                <span>
                  {
                    notificationsList.filter(
                      (notif) => !notif.isSeenByMe && !notif.notice.isDeleted
                    ).length
                  }
                </span>
              </Badge>
            )}
          </Link>
        </Nav>
      )}
      <Nav className="ms-auto" id="main__navbar-nav" navbar>
        <LanguageToggle />
        <ToggleHelp></ToggleHelp>
        <ButtonLogout />
      </Nav>

      <MobileLogout />

      {showNotifications && (
        <IntrusiveNotificationModal
          isOpen={showIntrusiveModal}
          notifications={intrusiveNotifications}
          onClose={handleCloseIntrusiveModal}
          onDismiss={handleDismissIntrusiveModal}
          onGoToNotificationCenter={handleGoToNotificationCenter}
        />
      )}
    </header>
  );
}

export default Header;
